import { createOnboardingStore } from './create-onboarding-store';

const useCorporateFIStore = createOnboardingStore('kyb_corporate_fi_draft', 5);

export { useCorporateFIStore };
